<template>
  <button class="message-author-avatar" type="button" @click="openProfileSlideOut">
    <img
      :alt="authorName"
      :src="authorAvatar"
      class="user-avatar"
      :height="34"
      :width="34"
    >
  </button>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import { DEFAULT_USER_AVATAR } from "%/constants/user-constants";
import { useMessageStore } from "%/apps/conversations/stores/message-store";

export default {
  name: "MessageAuthorAvatar",
  props: {
    avatarUrl: {
      type: String,
      required: false,
      default: null,
    },
    messageId: {
      type: Number,
      required: true,
    },
  },
  emits: ["open:profile"],
  computed: {
    ...mapState(useGeneralStore, ["userData"]),
    message() {
      return this.getMessage(this.messageId);
    },
    authorName() {
      if (this.isAuthor) {
        return useGeneralStore().userData.first_name;
      }
      return this.message.authorName;
    },
    authorId() {
      return this.message.userId;
    },
    isAuthor() {
      return this.isMessageAuthor(this.messageId);
    },
    authorAvatar() {
      if (this.avatarUrl) {
        return this.avatarUrl;
      }
      if (this.isAuthor) {
        return this.userData.avatar_url;
      }
      return DEFAULT_USER_AVATAR;
    },
  },
  methods: {
    ...mapActions(useMessageStore, ["getMessage", "isMessageAuthor"]),
    openProfileSlideOut() {
      this.$emit("open:profile", this.authorId);
    },
  },
  styleGuide: () => ({
    borderRadius: { "size.borderRadius": "large" },
    marginTop: { "size.spacing": "extraSmall" },
  }),
};
</script>

<style lang="scss" scoped>
.message-author-avatar {
  display: block;
  flex-shrink: 0;
  margin-top: v-bind("$getStyles.marginTop") !important;
  width: 34px;
  height: 34px;
  padding: 0 !important;
  border: none;
  background: transparent;
  cursor: pointer;
  &:hover {
    margin-top: v-bind("$getStyles.marginTop") !important;
  }
}

:deep(.user-avatar) {
  display: block;
  border-radius: v-bind("$getStyles.borderRadius");
  //margin-top: v-bind("$getStyles.marginTop") !important;
  object-fit: cover;
}
</style>
